import React from 'react';
import { SUPPORT_EMAIL, WHATSAPP_LABEL, WHATSAPP_URL } from './Shared';
export function Footer() {
  return <footer className="border-t border-brand-gold/40 bg-brand-ink py-12 text-brand-paper" data-id="element-75" data-mp="3ggap9r3mg53c">
      <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8" data-id="element-76" data-mp="32ovw4rg02nik">
        <p className="font-kanji text-2xl text-brand-goldLight/70" aria-hidden="true" data-id="element-77" data-mp="36p6bgupomqa3">
          針灸
        </p>
        <h3 className="mt-2 font-display text-3xl font-bold tracking-[0.06em] text-brand-goldLight" data-id="element-78" data-mp="3ugboz385h6h8">
          LUMEN AKASHA™
        </h3>
        <p className="mx-auto mt-3 max-w-2xl text-white/80" data-id="element-79" data-mp="36czunggsbik">
          El sistema visual de acupuntura clínica N°1 para terapeutas de
          Latinoamérica.
        </p>
        <p className="mx-auto mt-2 max-w-2xl text-white/70" data-id="element-80" data-mp="3qblvtm4vm600">
          Porque aplicar Medicina Tradicional China con excelencia no debería
          depender de cuánto recuerdas ese día.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 text-sm text-brand-goldLight sm:flex-row sm:gap-7" data-id="element-81" data-mp="2ezl3jx8szzfi">
          <a className="transition-colors duration-150 ease-out hover:text-brand-paper" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-82" data-mp="3gagz5ny8f937">
            📧 {SUPPORT_EMAIL}
          </a>
          <a className="transition-colors duration-150 ease-out hover:text-brand-paper" href={WHATSAPP_URL} data-id="element-83" data-mp="3q8n125k1gf82">
            📱 WhatsApp: {WHATSAPP_LABEL}
          </a>
          <a className="transition-colors duration-150 ease-out hover:text-brand-paper" href="https://instagram.com/lumen.akasha" data-id="element-84" data-mp="33xc3sjqnopv">
            📷 @lumen.akasha
          </a>
          <a className="transition-colors duration-150 ease-out hover:text-brand-paper" href="https://www.lumenakasha.com" data-id="element-85" data-mp="cu0h6r44wt4k">
            🌐 www.lumenakasha.com
          </a>
        </div>
        <div className="mt-10 space-y-2 text-xs text-white/50" data-id="element-86" data-mp="msppbs68az7m">
          <p data-id="element-87" data-mp="tv4n215bx24h">
            © Lumen Akasha™ 2026 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
          <p data-id="element-88" data-mp="yuhb2p7xsf8n">
            Ley 25.326 — Protección de Datos Personales — República Argentina
          </p>
        </div>
        <p className="mt-8 font-display text-sm italic text-brand-goldLight/75" data-id="element-89" data-mp="13rg2v144oa3o">
          “El terapeuta que tiene un sistema aplica con confianza. El que aplica
          con confianza genera resultados. El que genera resultados crece.”
        </p>
      </div>
    </footer>;
}